import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import moment from "moment";
import i18next from "i18next";

const sanitizedUrl = (url) => {
    if (url.startsWith('http')) {
        return url;
    } else {
        return 'https://' + url;
    }
};

const handleUrlClick = (e, url) => {
    e.preventDefault();
    window.open(sanitizedUrl(url), '_blank');
};

function Info({companies, events, urls, loading, map, host}) {
    const {t} = useTranslation();
    if (loading)
        return (
            <>
                <div className="media_image"></div>
                <div className="media_body">
                    <h3 className="company_name loading">&nbsp;</h3>
                    <p className="company_address loading"></p>

                    <table style={{width: '100%'}} className="company_contact loading">
                        <tbody>
                        <tr></tr>
                        <tr></tr>
                        <tr></tr>
                        <tr></tr>
                        <tr></tr>
                        </tbody>
                    </table>
                </div>
            </>
        );
    return (
        <>
            {(companies &&
                companies.length > 0 &&
                companies.map((company, index) => (
                    <div key={index}>
                        <div className="media_image">
                            {(company.LOGO && (
                                <img
                                    alt={company.NAME}
                                    src={`${host}/${map.path}/logos/${company.LOGO}`}
                                    height="auto"
                                    width="100"
                                />
                            )) || <div className="media_image"/>}
                        </div>
                        <div className="media_body">
                            <h3 className="company_name">
                                <b>{company.NAME}</b>
                            </h3>
                            <p className="company_address">
                                {company.ADRESSE ? (<div>{company.ADRESSE}</div>) : null}
                                {company.PLZ || company.STADT
                                    ? (i18next.language === 'en'
                                        ? (<div>{company.STADT}{company.STADT && company.PLZ ? ', ' + company.PLZ : company.PLZ}</div>)
                                        : (<div>{company.PLZ ? company.PLZ + ' ' : ''}{company.STADT}</div>))
                                    : null}
                                {company.LAND ? (<div>{company.LAND}</div>) : null}
                            </p>

                            { company.TELEFON || company.MOBILTELEFON || company.FAX || company.EMAIL || company.WEB
                                ? <table className="company_contact">
                                <tbody>
                                {company.TELEFON ? (<tr>
                                    <td>{t('companyTel')}</td>
                                    <td>{company.TELEFON}</td>
                                </tr>) : null}
                                {company.MOBILTELEFON ? (<tr>
                                    <td>{t('companyMobile')}</td>
                                    <td>{company.MOBILETELEFON}</td>
                                </tr>) : null}
                                {company.FAX ? (<tr>
                                    <td>{t('companyFax')}</td>
                                    <td>{company.FAX}</td>
                                </tr>) : null}
                                {company.EMAIL ? (<tr>
                                    <td>{t('companyEmail')}</td>
                                    <td>
                                        <a href={`mailto:${company.EMAIL}`}>{company.EMAIL}</a>
                                    </td>
                                </tr>) : null}
                                {company.WEB ? (<tr>
                                    <td>{t('companyWeb')}</td>
                                    <td>
                                        <a
                                            href={sanitizedUrl(company.WEB)}
                                            onClick={(e) => handleUrlClick(e, company.WEB)}
                                        >
                                            {company.WEB}
                                        </a>
                                    </td>
                                </tr>) : null}
                                </tbody>
                            </table>
                            : null
                            }
                        </div>
                        {companies.length > 0 && companies.length - index !== 1 && <hr/>}
                    </div>
                )))
            }
            {companies && companies.length > 0 && events && events.length > 0 && <hr/>}
            {events &&
                events.length > 0 &&
                ((new Set(
                    [].concat.apply([], events.map((event, _) => [event['BEGINN'], event['ENDE']]))
                        .map((date, _) => moment(date).format('DD.MM.YYYY'))
                ).size > 1)
                    ? <h5>{t('eventWithCountBetween', {
                        count: events.length,
                        start: moment(events[0]['BEGINN']).toDate(),
                        end: moment(events[events.length - 1]['ENDE']).toDate()
                    })}</h5>
                    : <h5>{t('eventWithCount', {
                        count: events.length,
                        date: moment(events[0]['BEGINN']).toDate()
                    })}</h5>)
            }
            {((events && events.length > 0) || (companies && companies.length > 0)) && urls && urls.length > 0 && <hr/>}
            {(urls &&
                urls.length > 0 &&
                urls.map((url, index) => (
                    <div key={index}>
                        <a
                            href={sanitizedUrl(url)}
                            onClick={(e) => handleUrlClick(e, url)}
                        >
                            {url}
                        </a>
                    </div>
                )))
            }
            {
                (!companies || companies.length === 0) && (!events || events.length === 0) && (!urls || urls.length === 0) &&
                <h5>{t('missingLocationInformation')}</h5>
            }
        </>
    );
}

Info.propTypes = {
    companies: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    map: PropTypes.object.isRequired,
};

export default Info;
